import React, { useState } from 'react';
import { toast } from 'react-toastify';

import ConfirmModal from 'components/Modals/confirmModal';

export default function RevertWipTestImplModal({ closeModal }) {
  const [loading, setLoading] = useState(false);

  const revertWipTestImpl = () => {
    setLoading(true);
    // TODO Make the current wip into live here and update context or redirect
    setTimeout(() => setLoading(false), 1000);
    toast.error('Revert WIP to live state not mplemented!');
  };

  return (
    <ConfirmModal
      title="Confirmation"
      text="Do you want to delete all current WIP implementation changes?"
      onCancel={closeModal}
      onConfirm={revertWipTestImpl}
      loading={loading}
    />
  );
}
